/** Format INR amounts for Performance Hub Campaign Economics UI. */

export function formatInr(amount, { compact = false } = {}) {
  if (amount == null || amount === '') return '—';
  const n = Number(amount);
  if (!Number.isFinite(n)) return '—';
  if (compact && n >= 100000) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(n);
  }
  let maximumFractionDigits = 2;
  if (n >= 100) maximumFractionDigits = 0;
  else if (n > 0 && n < 0.01) maximumFractionDigits = 4;
  else if (n < 1) maximumFractionDigits = 3;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits,
  }).format(n);
}

export function formatUnitMetric(value, suffix = '') {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const base = new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: n < 10 ? 2 : 0,
  }).format(n);
  return suffix ? `${base}${suffix}` : base;
}
